module.exports = __webpack_public_path__ + "files/ef80abc09f16078fbeda944906565caf.svg";